import deleteBiest from "./deleteBiest"

export default function eraseDataBase(list, setList){

    list.map((item)=>(deleteBiest(setList,item)))

}